<template>
  <Box class="distribution__container">
    <Box class="distribution__content">
      <Box class="distribution__left" is-flex flex-direction="column" align-items="center" justify-content="center">
        <img src="/images/landing/distribution.png" srcset="/images/landing/distribution@2x.png 2x">
      </Box>
      <Box class="distribution__right" is-flex flex-direction="row" align-items="center">
        <Glow class="distribution__glow" />
        <Box class="distribution__text" is-flex flex-direction="column" gap="6">
          <Box is-flex flex-direction="column" gap="1">
            <Heading size="h6" color="orange" letter-spacing="4" is-uppercase>{{ $t('pages.ssr_landing.distribution.subtitle') }}</Heading>
            <Heading class="distribution__title" color="purple-pink">{{ $t('pages.ssr_landing.distribution.title') }}</Heading>
          </Box>
          <CustomText size="large">{{ $t('pages.ssr_landing.distribution.description') }}</CustomText>
          <a :href="$locatedLink('/features/podcast-distribution/')">
            <Button class="link-button-arrow-animation" variant="transparent" size="medium" border-radius="large" has-border>
              <CustomText size="large" weight="bold">{{ $t('learn_more') }}</CustomText>
              <div class="link-button-arrow-animation__i">
                <SmallArrowIcon />
              </div>
            </Button>
          </a>
        </Box>
      </Box>
    </Box>
  </Box>
</template>

<script>
import Glow from './svg/Glow'
import Box from '@/components/common/Box/Box'
import Heading from '@/components/common/Heading/Heading'
import CustomText from '@/components/common/CustomText/CustomText'
import Button from '@/components/common/Button/Button'

import SmallArrowIcon from '@/components/icons/default/ArrowSmall'

export default {
  components: {
    Glow,
    Box,
    Heading,
    CustomText,
    Button,
    SmallArrowIcon
  }
}
</script>

<style lang="scss" scoped>
.distribution {
  &__container {
    padding: $gap * 5 $gap;

    @include display-less(tablet) {
      padding-bottom: 0;
    }
  }

  &__content {
    display: flex;
    flex-direction: row;
    max-width: 1200px;
    margin: 0 auto;
    border: 1px solid #342549;
    border-radius: 24px;
    overflow: hidden;

    @include display-less(tablet) {
      flex-direction: column-reverse;
    }
  }

  &__left {
    aspect-ratio: 1 / 1;
    width: 100%;
    max-width: 600px;
    flex: 1 1;
  }

  &__right {
    position: relative;
    background-color: #291840;
    flex: 1 1;
  }

  &__glow {
    position: absolute;
    top: 50px;
    left: -200px;
    width: 787px;
    height: 482px;
    pointer-events: none;
  }

  &__title {
    @include display-less(tablet) {
      font-size: 32px;
      line-height: 120%;
    }
  }

  &__text {
    padding: $gap * 3.5 $gap * 2.5;

    @include display-less(tablet) {
      padding: $gap * 3.5 $gap;
    }
  }
}
</style>
